import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "../../api-utility/axiosInstance";

// FETCH ALL BRANCHES
export const fetchAllBranches = createAsyncThunk(
  "branches/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const res = await Axios.get("/tenant/branch-managements", { params });
      if (res.data?.success === false) {
        return rejectWithValue(res.data.message);
      }
      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch branches",
      );
    }
  },
);

// CREATE BRANCH
export const addBranch = createAsyncThunk(
  "branches/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await Axios.post("/tenant/branch-managements", payload);
      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

// GET BRANCH BY ID
export const getBranchById = createAsyncThunk(
  "branches/getById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await Axios.get(`/tenant/branch-managements/${id}`);
      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }
      return res.data.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch branch",
      );
    }
  },
);

// UPDATE BRANCH
export const updateBranch = createAsyncThunk(
  "branches/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await Axios.put(`/tenant/branch-managements/${id}`, payload);
      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

// DELETE BRANCH
export const deleteBranch = createAsyncThunk(
  "branches/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await Axios.delete(`/tenant/branch-managements/${id}`);
      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || "Failed to delete branch");
    }
  },
);

// CHANGE BRANCH STATUS
export const changeBranchStatus = createAsyncThunk(
  "branches/changeStatus",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await Axios.post(
        `/tenant/branch-managements/${id}/change-status`,
      );
      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || "Failed to change status");
    }
  },
);

// BULK DELETE
export const bulkDeleteBranches = createAsyncThunk(
  "branches/bulkDelete",
  async (ids, { rejectWithValue }) => {
    try {
      const res = await Axios.delete("/tenant/branch-managements/bulk-delete", {
        data: { ids },
      });
      if (res.data?.success === false) {
        return rejectWithValue(res.data);
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || "Failed bulk delete");
    }
  },
);

const branchSlice = createSlice({
  name: "branches",
  initialState: {
    branches: [],
    total_records: 0,
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    // FETCH ALL BRANCHES
    builder
      .addCase(fetchAllBranches.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllBranches.fulfilled, (state, action) => {
        state.isLoading = false;
        state.branches = action.payload.data;
        state.total_records = action.payload.total_records;
      })
      .addCase(fetchAllBranches.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to fetch branches";
      });
  },
});

export default branchSlice.reducer;
